import type { ActorRefFrom } from 'xstate';
import { assign, setup } from 'xstate';

import type { ResidenceModel } from '@webapp/common/resources/entities';

import { surveyApi } from '@webapp/survey/src/machine/api';

const loadedResidences = Object.create(null);

type ResidenceEvent =
    | { type: 'LOAD_RESIDENCE'; level: number; parent: number }
    | { type: 'ADD_RESIDENCE'; residences: Array<ResidenceModel> };

enum ResidenceState {
    INITIAL = 'inintial',
    LOADING = 'loading',
    SUCCESS_LOADED = 'success_loaded',
    FAILED_LOADED = 'failed_loaded',
}

export const ResidenceMachineDefinition = setup({
    types: {
        context: {} as {
            questionId: number;
            residences: Array<ResidenceModel>;
        },
        events: {} as ResidenceEvent,
        input: {} as { questionId: number },
    },
}).createMachine({
    id: 'ResidenceMachine',
    initial: ResidenceState.INITIAL,
    context: ({ input: { questionId } }) => ({
        residences: [],
        questionId,
    }),
    states: {
        [ResidenceState.INITIAL]: {},
    },
    on: {
        ADD_RESIDENCE: {
            actions: assign(({ context, event }) => {
                return {
                    residences: context.residences.concat(event.residences),
                };
            }),
        },
    },
});

export type ResidenceActorRef = ActorRefFrom<typeof ResidenceMachineDefinition>;

export const loadResidencesItems = async (
    { questionId, level, parent }: { questionId: number; level: number; parent: number },
    actor: ResidenceActorRef,
) => {
    const key = `${questionId}_${level}_${parent}`;
    if (loadedResidences[key]) return [];

    let residences: Array<ResidenceModel> = [];

    try {
        residences = await surveyApi.getResidences(level, parent);
    } catch (e) {
        return [];
    }

    loadedResidences[key] = true;
    actor.send({ type: 'ADD_RESIDENCE', residences });
};
